// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module_wrapper_3_V9B","row":"index-module_row_qptrW","mRow":"index-module_mRow_V4ygF"};